export default "__VITE_ASSET__BxhURFJN__"